<template>
  <div>
    <b-container fluid class="content">
      <el-alert v-if="show_success" title="Success Updated !" type="success" effect="dark"></el-alert>
      <b-row class="mt-4">
        <b-col>
          <b-card no-body>
            <b-card-body>
              <b-form>
                <div class="row">
                  <div class="col-12 col-sm-6 col-lg-3 ">
                    <base-input :label="$t('From Date')">
                      <b-row>
                        <b-col>
                          <flat-pickr
                            :config="pickr_config"
                            class="form-control"
                            :placeholder="$t('From Date')+'...'"
                            v-model='from_date'
                          >
                          </flat-pickr>
                        </b-col>
                      </b-row>
                    </base-input>
                  </div>
                  <div class="col-12 col-sm-6 col-lg-3 ">
                    <base-input :label="$t('To Date')">
                      <b-row>
                        <b-col>
                          <flat-pickr
                            :config="pickr_config"
                            class="form-control"
                            :placeholder="$t('To Date')+'...'"
                            v-model='to_date'
                          >
                          </flat-pickr>
                        </b-col>
                      </b-row>
                    </base-input>
                  </div>
                  <div class="col-12 col-sm-6 col-lg-3 ">
                    <base-input :label="$t('Store')">
                      <select class="form-control" v-model="cur_store_id" @change="change_store()">
                        <option></option>
                        <option
                          v-for="(loc, idx) in storelist"
                          :key="idx"
                          :value="loc.LocationID"
                        >
                          {{ loc.LocationName }}
                        </option>
                      </select>
                    </base-input>
                  </div>
                  <div class="col-12 col-sm-12 col-lg-3 " v-if="source_list">
                    <base-input label="Source">
                      <select class="form-control" v-model="cur_source" >
                        <option
                          v-for="s in source_list"
                          :key="s"
                          :value="s"
                        >
                          {{ s }}
                        </option>
                      </select>
                    </base-input>
                  </div>
                  <div class="col-12 col-sm-6 col-lg-3 ">
                    <base-input :label="$t('Transaction') + '#'">
                      <b-input
                        class="form-control"
                        :placeholder="$t('Transaction') + '#'"
                        v-model="cur_transaction_no"
                      />
                    </base-input>
                  </div>
                  <div class="buttonRow col-12 col-sm-12 col-lg-3 ">
                    <div class="row">
                      <div class="col-6">
                        <b-button variant="primary" @click="form_search" style="float: right;">{{
                          $t("Search")
                        }}</b-button>
                      </div>
                      <!-- <div class="col-6" v-show="false">
                        <a v-bind:href="export_url" class="btn btn-primary" target="_blank">{{ $t("Export") }}</a>
                      </div> -->
                      <div class="col-6">
                        <xlsx-workbook>
                          <xlsx-sheet
                            v-for="sheet in sheets"
                            :collection="sheet.data"
                            :key="sheet.name"
                            :sheet-name="sheet.name"
                          />
                          <xlsx-download :filename="excel_filename" disable-wrapper-click>
                            <template #default="{download}">
                              <b-button variant="primary" style="float: none;" @click="excel_download(download)" v-show="!loadingDownload">{{ $t("Export") }}</b-button>
                            </template>
                          </xlsx-download>
                        </xlsx-workbook>
                        <!-- <b-button variant="primary" style="float: none;" @click="download()">{{ $t("Export" + '(JS2)') }}</b-button> -->
                        <b-spinner variant="primary" label="Spinning" v-show="loadingDownload"></b-spinner>
                      </div>
                    </div>
                  </div>
                </div>
              </b-form>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>

    <b-container fluid>
      <b-card>
        <b-card-body>
          <el-table :data="list_data" stripe @row-click="showReceiptModel" @sort-change="changeSort">
            <el-table-column :label="$t('Transaction') + '#'" prop="TransactionNo" sortable></el-table-column>
            <el-table-column :label="$t('Store')" prop="StoreID" sortable></el-table-column>
            <el-table-column :label="$t('Order Time')" prop="StatusDateTime" sortable></el-table-column>
            <el-table-column :label="$t('Subtotal')" prop="SubTotalAmount" sortable></el-table-column>
            <el-table-column :label="$t('Tax')" prop="AllTaxTotalAmount" sortable></el-table-column>
            <el-table-column :label="$t('Total')" prop="TotalAmount" sortable></el-table-column>
            <el-table-column :label="$t('Status')" prop="Status" sortable>
              <template #default="scope">
                <span v-if="scope.row.Status == 1">Finished</span>
                <span v-else-if="scope.row.Status < 0">Canceled</span>
                <span v-else></span>
              </template>
            </el-table-column>
          </el-table>
          <el-row style="margin-top: 20px">
            <el-col>
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                aria-controls="summary-table"
                ></b-pagination>
                <!-- @change="handlePageChanged" -->
            </el-col>
          </el-row>
        </b-card-body>
      </b-card>
    </b-container>
    <b-modal v-model="modalReceipt">
      <template #modal-title>
        <H3 class="text-center">{{ receipt_name }}</H3>
      </template>
      <b-row v-for="(item, idx) in receipt_rc.items" :key="idx" class="expand-class">
        <b-col cols="1">{{ item.Qty }}</b-col>
        <b-col cols="8">{{ item.Name }}</b-col>
        <b-col cols="2" class="text-right">${{ parseFloat(item.SubTotal).toFixed(2) }}</b-col>
        <b-col cols="12" v-if="item.Modifier&&(item.Modifier.length > 0)">
          <b-row v-for="(mod, idx) in item.Modifier" :key="idx">
            <b-col cols="12">{{ mod.Name }}<span v-if="mod.Qty!=1"> x {{ mod.Qty }}</span> <span v-if="mod.SubTotal"> ${{ parseFloat(mod.SubTotal).toFixed(2) }}</span></b-col>
          </b-row>
        </b-col>
      </b-row>
      <hr style="border-top: 1px dashed #ccc; margin: .1rem 0;">
      <b-row v-for="(total, idx) in receipt_rc.totals" :key="idx" class="expand-class">
        <b-col cols="9">{{ total.Name }}</b-col>
        <b-col cols="2" class="text-right">${{ parseFloat(total.SubTotal).toFixed(2) }}</b-col>
      </b-row>
      <hr style="border-top: 1px dashed #ccc; margin: .1rem 0;">
      <b-row>
        <b-col class="text-center">PAYMENT PROCESSOR</b-col>
      </b-row>
      <b-row v-for="(payment, idx) in receipt_rc.payments" :key="idx" class="expand-class">
        <b-col cols="9">{{ payment.ID }}</b-col>
        <b-col cols="2" class="text-right">${{ parseFloat(payment.SubTotal).toFixed(2) }}</b-col>
      </b-row>
      <template #modal-footer>
        <b-button variant="secondary" @click="modalReceipt=false">
          Close
        </b-button>
      </template>  
    </b-modal>
    <!-- <vue-element-loading
      :active="showloading"
      spinner="bar-fade-scale"
      color="#FF6700"
      duration="2.0"
      background-color="rgba(255, 255, 255, .5)"
      size="100"
    /> -->
  </div>
</template>
<script>
import { Table, TableColumn, Button, Pagination, Alert, Checkbox, Row, Col, Switch, } from "element-ui";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { getStore, setStore } from "../../util/helper";

import { XlsxWorkbook, XlsxSheet, XlsxDownload } from "vue-xlsx";
import { hasUtilityAuth } from "../../directives/acl";

const axios = require("axios");

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Button.name]: Button,
    [Pagination.name]: Pagination,
    [Alert.name]: Alert,
    [Checkbox.name]: Checkbox,
    [Row.name]: Row,
    [Col.name]: Col,
    [Switch.name]: Switch,
    [flatPicker.name]: flatPicker,
    XlsxWorkbook,
    XlsxSheet,
    XlsxDownload,
  },
  data() {
    return {
      per_page_option: [5, 10, 20],
      perPage: 12,
      currentPage: 1,
      totalRows: 0,
      orderBy: "",
      modalReceipt: false,
      receipt_name: "",
      receipt_rc: false,
      fields: [
        {
          key: 'Note',
          label: 'Note',
          checkbox: true,
          sortable: false,
          tdClass: 'summary_row',
          thClass: "summary_header_note",
          thStyle: { width: "2%" },
          note_permission: true,
        },
        {
          key: 'StatusDateTime',
          label: 'Date',
          sortable: true,
          tdClass: 'summary_row',
          thClass: "summary_header",
          thStyle: { width: "10%" },
        },
        {
          key: 'StoreName',
          label: 'Store',
          sortable: true,
          tdClass: 'summary_row',
          thClass: "summary_header",
          thStyle: { width: "10%" },
        },
        {
          key: 'TransactionNo',
          label: 'Transaction #',
          sortable: true,
          tdClass: 'summary_row',
          thClass: "summary_header",
          thStyle: { width: "13.5%" },
        },
        {
          key: 'SummarySubtotal',
          label: 'Subtotal',
          sortable: true,
          tdClass: 'summary_row_right',
          thClass: "summary_header",
          thStyle: { width: "8%" },
        },
        {
          key: 'SummaryDiscountSubtotal',
          label: 'Discount',
          sortable: true,
          tdClass: 'summary_row_right',
          thClass: "summary_header",
          thStyle: { width: "8%" },
        },
        {
          key: 'SummaryTax',
          label: 'Tax',
          sortable: true,
          tdClass: 'summary_row_right',
          thClass: "summary_header",
          thStyle: { width: "8%" },
        },
        {
          key: 'SummarySurcharge',
          label: 'Surcharge',
          sortable: true,
          tdClass: 'summary_row_right',
          thClass: "summary_header",
          thStyle: { width: "8%" },
          tdClass: 'summary_row_right',
          thClass: "summary_header",
          thStyle: { width: "8%" },
        },
        {
          key: 'SummaryAllTotal',
          label: 'Total',
          sortable: true,
          tdClass: 'summary_row_right',
          thClass: "summary_header",
          thStyle: { width: "8%" },
        },
        {
          key: 'TotalPaidAmount',
          label: 'Payment',
          sortable: true,
          tdClass: 'summary_row_right',
          thClass: "summary_header",
          thStyle: { width: "8%" },
        },
        {
          key: 'PaymentStr',
          label: 'Method',
          sortable: true,
          tdClass: 'summary_row_payment',
          thClass: "summary_header",
          thStyle: { width: "15%" },
        },
      ],
      filter_DateTime: null,
      filter_Store: null,
      filter_TransactionNo: null,
      filter_Subtotal: null,
      filter_Discount: null,
      filter_Tax: null,
      filter_Surcharge: null,
      filter_Gratuity: null,
      filter_PaidTotal: null,
      filter_AllTotal: null,
      filter_Payment: '',
      pickr_config: {
        dateFormat: "Y-m-d",
        maxDate: "today"
      },
      pickr_config2: {
        dateFormat: "Y-m-d",
        maxDate: "today",
        allowInput: false,
        enable: [],
        onChange: (selectedDates, dateStr, instance) => {
          this.filterTable();
        },
      },
      pickr_config3: {
        allowInput: true,
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
        maxDate: '23:59',
        time_24hr: true,
      },
      pickr_config4: {
        allowInput: true,
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
        maxDate: '23:59',
        time_24hr: true,
      },
      titleStyleObject: {
        textAlign: 'center',
        // textDecoration: 'underline',
        fontWeight: 'bold',
        fontSize: '24px',
      },
      infoStyleObject: {
        textAlign: 'left',
        fontWeight: 'bold',
        fontSize: '18px',
      },
      infodStyleObject: {
        textAlign: 'left',
        fontWeight: '2px',
        fontSize: '18px',
      },
      markStyleObject: {
        textAlign: 'left',
        fontWeight: 'bold',
        fontSize: '20px',
      },
      headerStyleObject: {
        textAlign: 'center',
        fontWeight: 'bold',
        fontSize: '18px',
      },
      titStyleObject: {
        textAlign: 'left',
        fontWeight: 'bold',
        fontSize: '18px',
        paddingLeft:'30px',
      },
      tidStyleObject: {
        textAlign: 'left',
        fontWeight: '2px',
        paddingLeft:'30px',
        fontSize: '18px',
      },
      nameStyleObject: {
        textAlign: 'center',
        fontWeight: '2px',
      },
      tftStyleObject: {
        fontWeight: 'bold',
      },
      rftStyleObject: {
        fontWeight: 'bold',
        fontSize: '19px',
      },
      rfdStyleObject: {
        fontWeight: '2px',
        fontSize: '19px',
      },
           
      row_dashed: {
        borderTop: '1px dashed #bbb',
        borderBottom: '1px dashed #bbb',
      }, 
      hr_dashed: {
        borderTop: '3px dashed #bbb',
      },
      hr_dotted: {
        borderTop: '3px dotted #bbb',
      },
      hr_solid: {
        borderTop: '3px solid #bbb',
        marginTop: '16px',
        marginBottom: '16px',
      },
      hr_rounded: {
        borderTop: '8px solid #bbb',
        borderRadius: '5px',
      },

      showloading: false,
      selectAll: false,

      token: "",
      user_id: 0,

      list_data: null,
      storelist: null,
      source_list: null,  // Platform like pandaapi / uber
      available_item_tax_list: null,
      summary_subtotal: null,
      summary_discount_subtotal: null,
      summary_tax: null,
      summary_surcharge: null,
      summary_gratuity: null,
      summary_alltotal: null,
      summary_total: null,
      summary_paidtotal: null,
      display_from_date: null,
      display_to_date: null,
      display_transaction_no: null,
      display_store_name: null,
      display_payment_name: null,
      
      pkadmin: false,
      posking: false,
      from_date: null,
      to_date: null,
      cur_transaction_no: null,
      cur_store_id: null,
      cur_source: null,

      export_url: "",
      show_success: false,
      donote: 0,
      report_width: null,

      loadingDownload: false,
      readyDownload: false,
      sheets: [
        { name: "ThirdPartyReport", data: [[1, 2, 2], [1, 2, 2, 2], [], [1, 2, 2, 2]] },
      ],
      excel_filename: 'ThirdPartyReport.xlsx',
      excel_title: [],
      excel_summary: [],
      excel_total: 0,
      excel_data: [],

      delay_search_timer: null,
      arrloading: [],
    };
  },
  watch: {
    currentPage: function(val){
      this.delay_get_currentPage_data(true);
    },
    // perPage: function(val){
    //   this.delay_get_currentPage_data(true);
    // },
  },
  computed: {
  },
  methods: {
    hasUtilityAuth,
    showReceiptModel(row, column, event) {
      // console.log("row-click showReceiptModel", row, column, event);
      this.modalReceipt = true;
      this.receipt_name = row.TransactionNo;
      this.receipt_rc = JSON.parse(row.Info);
    },
    sortTableData(prop, order) {
      // Clone table data to avoid mutating original
      let sortedData = [...this.list_data]; // Create a copy to avoid modifying the original array

      // Custom sorting logic
      sortedData.sort((a, b) => {
        let valA = a[prop];
        let valB = b[prop];

        // Handle different data types (e.g., strings, numbers)
        if (typeof valA === 'string') {
          valA = valA.toLowerCase();
          valB = valB.toLowerCase();
        }

        if ((prop == "SubTotalAmount") || (prop == "AllTaxTotalAmount") || (prop == "TotalAmount")) {
          valA = parseFloat(valA);
          valB = parseFloat(valB);
        }
        // Sorting based on order
        let rt = 0;
        if (order == "descending") {
          rt = valA > valB ? 1 : -1;
        } else { // ascending
          rt = valA < valB ? 1 : -1;
        }
        return rt;
      });

      // Update table data
      this.listdata = sortedData;

      // Example: Simulate server-side sorting with API call
      // this.fetchSortedData(prop, order);
    },
    changeSort(column) {
      // console.log("sort-change changeSort", column);
      if (column.order) {
        this.sortTableData(column.prop, column.order);
      }
    },
    // handlePageChanged(value) {
    //   this.currentPage = value;
    //   this.delay_get_currentPage_data(true);
    // },
    delay_get_currentPage_data(filtering = false) {
      if (this.delay_search_timer) {
        clearTimeout(this.delay_search_timer);
        this.delay_search_timer = null;
      }
      var that = this;
      this.delay_search_timer = setTimeout(() => {
        that.get_currentPage_data(filtering);
      }, 400);
    },
    async get_currentPage_data() {
      this.showloading = true;
      await this.get_data();
      this.showloading = false;
    },
    async excel_download(download) {
      var bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);
      bodyFormData.append("FromDate", this.from_date);
      bodyFormData.append("ToDate", this.to_date);
      bodyFormData.append("IsInit", 0);

      if (this.cur_transaction_no) {
        bodyFormData.append("TransactionNo", this.cur_transaction_no);
      }
      if (this.cur_store_id) {
        bodyFormData.append("StoreID", this.cur_store_id);
      }
      if (this.cur_source) {
        bodyFormData.append("Source", this.cur_source);
      }
      let limit = 3000;
      bodyFormData.append("page", 1);
      bodyFormData.append("per_page", limit);
      bodyFormData.append("order_by", this.orderBy);
      //////////////////////////////////////////////////////////////////////////
      this.loadingDownload = true;
      this.excel_data = [];
      this.excel_total = 0;
      let offset = 0;
      let that = this;
      axios({
        method: "post",
        url: "/Api/Web/third_party_report",
        data: bodyFormData,
      })
        .then(function (response) {
          if (response.status == "200") {
            var rt = response.data;
            if (rt.status == 0) {
              let list_data = rt.data.list_data;
              if (!list_data) {
                alert("Get Export Data error");
                return;
              }
              let totalRows = list_data.length;
              // console.log("excel_download Got Data", list_data);

              let printDate = that.get_today();
              that.sheets = [{name: "ThirdPartyReport", data: []}];
              that.excel_filename = 'ThirdPartyReport_' + printDate + '.xlsx';
              that.excel_title.push('Print Date: ' + printDate);
              if (that.excel_title.length < 9) {
                for (let i = that.excel_title.length; i <= 9; i++) {
                  that.excel_title.push('');
                }
              }
              that.sheets[0].data.push(that.excel_title);
              that.sheets[0].data.push(['','','','','','','','','']);
              that.sheets[0].data.push(['Transaction#', 'Store', 'Date Time', 'Subtotal', 'Tax', 'Total', 'Status']);
              
              for (let i = 0; i < totalRows; i++) {
                let rowData = [
                  list_data[i].TransactionNo,
                  list_data[i].StoreID,
                  list_data[i].StatusDateTime,
                  list_data[i].SubTotalAmount,
                  list_data[i].AllTaxTotalAmount,
                  list_data[i].TotalAmount,
                  (list_data[i].Status==1)?'Finished':((list_data[i].Status<0)?'Canceled':'Unknown Status'),
                ];
                that.sheets[0].data.push(rowData);
              }
              
              that.loadingDownload = false;
              that.$nextTick(() => {
                download();
              });
            } else if (rt.status == 4) {
              alert(that.$t("No Permission"));
              that.$router.go(-1);
            } else if (rt.message != undefined) {
              alert(rt.message);
            }
          }
          else {
            that.$router.push("/login");
          }
        })
        .catch(function (error) {
          // console.log(error);
          that.$router.push("/login");
        });
    }, 
    async form_search() {
      this.get_data();
    },
    change_store() {
      if (this.cur_store_id) {
        for (let i=0; i<this.storelist.length; i++) {
          this.source_list = null;
          if (this.storelist[i].LocationID == this.cur_store_id) {
            // Changed to this store.
            if (Array.isArray(this.storelist[i].online_store) && (this.storelist[i].online_store.length > 1)) {
              this.source_list = this.storelist[i].online_store;
            }
          }
        }
      }
    },
    get_today() {
      var today = new Date();
      // console.log('today', today);
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = today.getFullYear();
      return yyyy + '-' + mm + '-' + dd;
    },

    async get_data(IsInit=0) {
      var bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);
      bodyFormData.append("FromDate", this.from_date);
      bodyFormData.append("ToDate", this.to_date);
      bodyFormData.append("IsInit", IsInit);
      if (this.cur_transaction_no) {
        bodyFormData.append("TransactionNo", this.cur_transaction_no);
      }
      if (this.cur_store_id) {
        bodyFormData.append("StoreID", this.cur_store_id);
      }
      if (this.cur_source) {
        bodyFormData.append("Source", this.cur_source);
      }
      bodyFormData.append("page", this.currentPage);
      bodyFormData.append("per_page", this.perPage);
      bodyFormData.append("order_by", this.orderBy);

      var that = this;

      axios({
        method: "post",
        url: "/Api/Web/third_party_report",
        data: bodyFormData,
      })
        .then(function (response) {
          if (response.status == "200") {
            var rt = response.data;
            if (rt.status == 0) {
              if (IsInit) {
                that.storelist = rt.data.storelist;
                that.source_list = null;
              }
              that.list_data = rt.data.list_data;
              that.totalRows = rt.data.total;
              // console.log("get_data >>>>", that.list_data);
            } else if (rt.status == 4) {
              alert(that.$t("No Permission"));
              that.$router.go(-1);
            } else if (rt.message != undefined) {
              alert(rt.message);
            }
          }
          else {
            that.$router.push("/login");
          }
        })
        .catch(function (error) {
          // console.log(error);
          that.$router.push("/login");
        });
    },
    async init_data() {
      var dt = new Date();
      var dd = String(dt.getDate()).padStart(2, '0');
      var mm = String(dt.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = dt.getFullYear();

      this.from_date = yyyy + '-' + mm + '-01';
      this.to_date = this.get_today();
      this.token = getStore("token");
      this.user_id = getStore("user_id");
      this.get_data(1);
    },
  },
  mounted() {
    let name = getStore("username");
    if (name == "PKAdmin") {
      this.pkadmin = true;
    }
    if (name == "posking") {
      this.posking = true;
    }
    this.init_data();
    this.windowHeight = window.innerHeight;
  },
};
</script>
<style scope>
.card .table td, .card .table th {
  padding-left: .125rem;
  padding-right: .125rem;
}
.modal-header .close {
  padding: .5rem 1.25rem .5rem 1.25rem;
}
.modal-header {
  padding: 1rem 1.25rem .5rem 1.25rem;
}
</style>
<style scope>
@media (min-width:992px) {
  .buttonRow {
    margin-top: 25px;
  }

  .switchElement {
    margin-top: 1rem;
    /* margin-left: 4rem; */
    text-align: center;
  }
}
@media (min-width:0px) and (max-width:1200px){
  .searchParam {
    font-size: 1rem !important;
  }
}
@media (min-width:1601px) {
  .tableHeader {
    font-size: .9rem !important;
    text-transform: initial !important;
    text-align: center;
  }
  .tableRow {
    font-size: 0.9rem !important;
  }
  .tableFooter {
    font-size: 1rem !important;
  }
}
@media (min-width:1401px) and (max-width:1600px){
  .tableHeader {
    font-size: 0.7rem !important;
    text-transform: initial !important;
    text-align: center;
  }
  .tableRow {
    font-size: 0.7rem !important;
  }
  .tableFooter {
    font-size: 1rem !important;
  }
}
@media (min-width:1181px) and (max-width:1400px){
  .tableHeader {
    font-size: 0.6rem !important;
    text-transform: initial !important;
    text-align: center;
  }
  .tableRow {
    font-size: 0.6rem !important;
  }
  .tableFooter {
    font-size: .8rem !important;
  }
}
@media (min-width:0px) and (max-width:1180px){
  .tableHeader {
    font-size: 0.6rem !important;
    text-transform: initial !important;
    text-align: center;
  }
  .tableRow {
    font-size: 0.6rem !important;
  }
  .tableFooter {
    font-size: 0.8rem !important;
  }
}
.content {
  padding-top: 60px;
}
.summary_row {
  font-size: 1rem !important;
  text-align: center;
  white-space: unset !important;
}
.summary_row_right {
  font-size: 1rem !important;
  text-align: right;
  white-space: unset !important;
}
.summary_row_payment {
  font-size: 1rem !important;
  white-space: unset !important;
}
.summary_header {
  font-size: 1.0035rem !important;
  white-space: unset !important;
}
.summary_header_note {
  font-size: 1.0035rem !important;
  white-space: unset !important;
  text-align: center;
}
.detail_row {
  font-size: 1rem !important;
  white-space: unset !important;
}
.detail_header {
  font-size: 1.0035rem !important;
  white-space: unset !important;
}
.flatpickr-input {
  background-color: #ffffff !important;
}
#filterTableFP {
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
  border-color: #ced4da !important;
}
.modal-title {
  width: 100%;
}
</style>
<style scoped src="bootstrap/dist/css/bootstrap.css"></style>
<style src="bootstrap-vue/dist/bootstrap-vue.css"></style>
